import { render, staticRenderFns } from "./MarketingSiteGallery.vue?vue&type=template&id=708e945a&scoped=true"
import script from "./MarketingSiteGallery.vue?vue&type=script&lang=js"
export * from "./MarketingSiteGallery.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteGallery.vue?vue&type=style&index=0&id=708e945a&prod&lang=scss&scoped=true"
import style1 from "./MarketingSiteGallery.vue?vue&type=style&index=1&id=708e945a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e945a",
  null
  
)

export default component.exports